{
  "title": "Importaciones",
  "dropzone": {
    "title": "Suelta aquí un PDF o una imagen",
    "hint": "o haz clic para elegir un archivo",
    "unsupported": "Tipo de archivo no compatible. Usa PDF, PNG o JPEG.",
    "tooManyPages": "Este documento tiene demasiadas páginas para cargarlo.",
    "pageTooLarge": "Una de las páginas es demasiado grande para procesarla.",
    "fileTooLarge": "Este archivo es demasiado grande.",
    "noFileReceived": "No se recibió ningún archivo. Inténtalo de nuevo o arrastra el archivo a este recuadro.",
    "accepted": "Formatos aceptados: PDF, PNG, JPEG",
    "prepareFailed": "No se pudieron preparar algunas páginas. Consulta la lista.",
    "converting": "Preparando páginas..."
  },
  "extract": {
    "button": "Extraer texto",
    "cancel": "Cancelar",
    "progress": "Extrayendo la página {{current}} de {{total}}...",
    "serviceNotReady": "El servicio de extracción no está disponible en este momento.",
    "noOcrLines": "No se encontró texto en esta página.",
    "ocrProgress": "Leyendo el texto de la página {{current}} de {{total}}...",
    "clear": "Limpiar",
    "cancelled": "Cancelado. Las páginas completadas se conservan.",
    "cancelling": "Cancelando...",
    "retryHint": "Presiona Extraer de nuevo para reintentar solo las páginas con error.",
    "partialFailure": "No se pudieron procesar algunas páginas. Consulta la lista.",
    "noSelection": "Selecciona las páginas que quieres extraer.",
    "reviewLabel": "Revisar escritos a mano y enmiendas (usa imágenes de página)",
    "reviewHint": "Más lento. Los cambios solo se sugieren, nunca se aplican automáticamente.",
    "reviewProgress": "Revisando enmiendas en la página {{current}} de {{total}}...",
    "retryReview": "Reintentar revisión ({{count}})",
    "scanTablesLabel": "Escanear tablas (formatos estructurados como divulgaciones de cierre)",
    "scanTablesHint": "Más lento y costoso por página. Las páginas ya extraídas no se vuelven a leer.",
    "keptEdits": "Se conservaron {{count}} valor(es) editados en lugar de reemplazarlos con la nueva extracción."
  },
  "editor": {
    "title": "Editor de Markdown",
    "placeholder": "El texto extraído aparecerá aquí...",
    "lines": "Líneas",
    "noLines": "Aún no hay líneas.",
    "source": "Página {{page}}, línea {{line}}",
    "lineNo": "Línea {{line}}",
    "advanced": "Markdown para el asistente",
    "advancedHint": "Solo lectura. Edite los valores en la lista; esto es lo que recibe el asistente."
  },
  "badge": {
    "unknown-key": "Clave desconocida",
    "manual": "Manual",
    "malformed": "Mal formado",
    "phase-2": "Fase 2",
    "unverified": "Sin verificar"
  },
  "viewer": {
    "title": "Fuente",
    "zoom": "Zoom",
    "noSource": "Sin ubicación de origen",
    "noPages": "No hay páginas para mostrar.",
    "page": "Página {{page}}",
    "pageOf": "Página {{page}} de {{total}}",
    "previousPage": "Página anterior",
    "nextPage": "Página siguiente",
    "selectPage": "Seleccionar página",
    "boxLabel": "Línea: {{text}}",
    "enlarge": "Ampliar página",
    "close": "Cerrar",
    "previewTitle": "{{file}} - página {{page}}",
    "unusedBox": "Ninguna línea de datos usa este texto."
  },
  "target": {
    "title": "Destino",
    "new": "Nuevo",
    "existing": "Existente",
    "transactionType": "Tipo de transacción",
    "type": "Tipo",
    "workflow": "Flujo de trabajo",
    "agency": "Agencia",
    "searchOrder": "Buscar orden",
    "incomplete": "Completa los campos de destino antes de enviar.",
    "searchHint": "Escribe al menos 2 caracteres para buscar órdenes.",
    "searching": "Buscando órdenes...",
    "noResults": "No se encontraron órdenes.",
    "searchError": "No se pudieron buscar las órdenes. Inténtalo de nuevo."
  },
  "handoff": {
    "button": "Enviar al Asistente",
    "note": "El asistente recibirá el texto extraído y el destino seleccionado.",
    "confirmation": "Enviado al asistente.",
    "notReady": "Extrae el texto y selecciona un destino antes de enviar."
  },
  "errors": {
    "generic": "Algo salió mal. Por favor, inténtalo de nuevo.",
    "ocrFailed": "No se pudo reconocer el texto de esta página.",
    "extractFailed": "No se pudo extraer el documento."
  },
  "pages": {
    "title": "Páginas",
    "empty": "Aún no hay páginas.",
    "pending": "Pendiente",
    "done": "Listo",
    "error": "Error",
    "skipped": "Omitida",
    "cancelled": "Cancelada",
    "extracted": "Extraída",
    "lineCount": "{{total}} líneas",
    "thumbnailAlt": "{{file}}, página {{page}}",
    "preview": "Vista previa de {{file}}, página {{page}}",
    "openPreview": "Abrir vista previa completa de {{file}}, página {{page}}",
    "select": "Seleccionar {{file}}, página {{page}} para la extracción",
    "selectedCount": "{{selected}} de {{max}} páginas seleccionadas",
    "clearSelection": "Limpiar selección",
    "limitReached": "Puedes seleccionar hasta {{max}} páginas a la vez. Extráelas o quita una de la selección para elegir otras."
  },
  "issues": {
    "ocrError": "Falló el reconocimiento de texto",
    "extractError": "Falló la extracción",
    "noLines": "No se encontró texto",
    "reviewError": "Falló la revisión de enmiendas",
    "tableCheck": "Las tablas requieren revisión (totales o formato)"
  },
  "amendments": {
    "title": "Enmiendas por revisar",
    "hint": "Valores escritos a mano o corregidos encontrados en la página. Acepta para actualizar los datos, o descarta.",
    "current": "Actual",
    "suggested": "Sugerido",
    "accept": "Aceptar",
    "dismiss": "Descartar",
    "line": "línea {{line}}",
    "noSource": "Sin línea de origen",
    "confirmAmountTitle": "Confirmar cambio de monto",
    "confirmAmountReplace": "¿Cambiar {{key}} de {{current}} a {{suggested}}?",
    "confirmAmountAdd": "¿Agregar {{key}} con {{suggested}}? Esta página no tiene un valor actual para él.",
    "confirm": "Confirmar",
    "announce": "Enmiendas sugeridas por revisar: {{count}}"
  },
  "groups": {
    "order": "Orden",
    "party": "Partes",
    "property": "Propiedad",
    "loan": "Préstamo",
    "charge": "Cargos",
    "amount": "Montos",
    "note": "Notas",
    "other": "Otros"
  },
  "rows": {
    "summary": "{{lines}} líneas · {{flagged}} por revisar",
    "nextFlagged": "Siguiente marcado",
    "valueFor": "Valor de {{key}}",
    "edited": "Editado",
    "showSource": "Mostrar fuente en la página",
    "noSource": "Esta línea no tiene fuente",
    "showSourceFor": "Mostrar fuente de {{key}}",
    "originalValue": "Original: {{value}}",
    "resetFor": "Restablecer {{key}} al valor original",
    "removeFor": "Quitar {{key}}",
    "removed": "Quitados",
    "showOnlyFor": "Mostrar solo {{key}}",
    "restore": "Restaurar"
  },
  "links": {
    "announce": "{{key}}, página {{page}}, línea {{line}} seleccionada"
  },
  "tabs": {
    "label": "Vistas",
    "list": "Lista",
    "markdown": "Markdown",
    "restore": "Restaurar"
  },
  "send": {
    "clearTitle": "¿Limpiar la conversación actual?",
    "clearBody": "El asistente ya tiene una conversación abierta. Al enviar esta importación se limpia primero, para que la nueva importación empiece con un historial limpio.",
    "clearConfirm": "Limpiar y enviar",
    "busy": "El asistente todavía está respondiendo. Espere a que termine y envíe después."
  },
  "filter": {
    "label": "Filtrar",
    "placeholder": "Filtrar por clave, etiqueta o valor",
    "empty": "Ninguna fila coincide con el filtro.",
    "clear": "Limpiar filtro"
  },
  "steps": {
    "label": "Pasos de la importación",
    "document": "Documento",
    "review": "Revisión",
    "send": "Envío",
    "back": "Atrás",
    "next": "Siguiente",
    "close": "Cerrar"
  }
}
